/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Nav, NavItem } from "reactstrap";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

export const PartnerLinks = ({ partnerInfo }) => (
  <Nav className="justify-content-center justify-content-xl-start">
    <NavItem>
      <Button
        tag="a"
        color="facebook"
        className="px-3 mr-3"
        href="#/"
        onClick={(e) => e.preventDefault()}
      >
        <FontAwesomeIcon icon={faFacebook} className="font-size-lg" />
      </Button>
    </NavItem>
    <NavItem>
      <Button
        tag="a"
        color="twitter"
        className="px-3 mr-3"
        href="#/"
        onClick={(e) => e.preventDefault()}
      >
        <FontAwesomeIcon icon={faTwitter} className="font-size-lg" />
      </Button>
    </NavItem>
    <NavItem>
      <Button
        tag="a"
        color="instagram"
        className="px-3"
        href="#/"
        onClick={(e) => e.preventDefault()}
      >
        <FontAwesomeIcon icon={faInstagram} className="font-size-lg" />
      </Button>
    </NavItem>
  </Nav>
);
